export default "__VITE_ASSET__zMxBgpnr__"